(function(){
     'use strict';

     angular
        .module('appauth')
        .factory('RegistroService', RegistroService);

    RegistroService.$inject = ['$http'];

    function RegistroService($http){


        var service= {
            getProductos: getProductos,
            getPrueba:getPrueba,
            setRegistro:setRegistro,
            getPaises:getPaises
        };

        return service;

        function getPrueba(callback)
        {
            console.log('getPrueba sserrvice')
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/auth/pruebame', { params : { param:'HOlaHola'}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('getPrueba getContentFailed', data)
                
                return false;
            }
            
        }
        function getPaises(callback)
        {
            console.log('getPaises sserrvice')
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/auth/getpaises', { params : { param:'damepais'}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                console.log('getPaises getContentFailed', data)
                
                return false;
            }
            
        }
        function setRegistro(formReg,callback)
        {
            console.log('setRegistro',formReg)
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({formReg});
            console.log('data',data)
            $http.post('/auth/registrar', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }     

        function getProductos(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
            });
            $http.post('/backend/productos/getproductos', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

    }
})();